export default __webpack_public_path__ + "static/media/coach-bundle_gray@1x.6e4f7471.webp";